// extracted by mini-css-extract-plugin
export var fileExt = "_s6-8";
export var fileIcon = "_s6-6";
export var fileLink = "_s6-5";
export var fileName = "_s6-7";
export var image = "_s6-1";
export var imageError = "_s6-3";
export var imageErrorIcon = "_s6-4";
export var imageLink = "_s6-0";
export var imageLoaded = "_s6-2";